import { render, staticRenderFns } from "./Hold.vue?vue&type=template&id=069ae904&scoped=true"
import script from "./Hold.vue?vue&type=script&lang=ts"
export * from "./Hold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ae904",
  null
  
)

export default component.exports